import { render, staticRenderFns } from "./TeasingVideo.vue?vue&type=template&id=286a18ad"
import script from "./TeasingVideo.vue?vue&type=script&lang=js"
export * from "./TeasingVideo.vue?vue&type=script&lang=js"
import style0 from "./TeasingVideo.vue?vue&type=style&index=0&id=286a18ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports